<!-- <app-view-more [(visible)]="displayViewMore" [property]="propertyDetail"></app-view-more> -->
<app-header [pageName]="pageName" [viewSignUp]="displayReg" [viewSignIn]="displayLogin"
  (closeAuthForms)="closeForms($event)"></app-header>

<app-view-more [(visible)]="displayViewMore" [property]="propertyDetail" [user]="user"></app-view-more>
<app-filters [(visible)]="displayFilters" (filterData)="getFilters($event)"></app-filters>

<!-- <div *ngIf="fbConnected" class="floating-join"> 
  <div class="linkFB">
    <a href="https://ganimarketevent.auth.us-east-1.amazoncognito.com/oauth2/authorize?redirect_uri=https://localhost:4200&response_type=token&client_id=2r1j7mbji23eo4qoujo8ncm1dd&identity_provider=Facebook" target="_blank">Sign in with Facebook</a>
  </div> 
  
  <div class="link"> 
    <a (click)="signInWithGoogle()">Sign in with Google</a>
  </div>
</div> -->

<div class="page-header header-color">
  <!-- <button class="btn btn-primary" (click)="onTestAuthUser()">Testing</button> -->
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h1 class="title">Welcome Property Owners</h1>
        <p class="subtitle">Welcome to our market place where we connect property owners to sponsors. For this market
          place to be effective we require property owners to register
          their properties (what they need to be sponsored) along with the property name, description, sponsorship fees,
          date,
          attendance, category, location and more.</p>
      </div>
      <div class="col-md-6 d-flex justify-content-center">
        <img class="logo" src="../../assets/images/logo_white.png" alt="">
      </div>
    </div>

    <div class="input_div">
      <form>
        <div class="input-group">
          <input type="text" name="searchText" class="form-control search-input border-0 small" [(ngModel)]="searchText"
            placeholder="Search for event..." aria-label="Search" aria-describedby="basic-addon2">
          <div class="input-group-append">
            <button class="btn btn-primary btn-search" (click)="onQuerySearch()" type="button">
              <i class="fa fa-search fa-sm"></i>
            </button>
          </div>
        </div>
      </form>
    </div>

    <!-- Filter Button -->
    <div class="row mb-2 filter-button">
      <div class="col-md-12">
        <button type="button" (click)="onFilter()" class="btn btn-outline-light shadow lift">
          <p style="color: black; margin: 0; padding: 0">Filter</p>
        </button>
      </div>
    </div>

  </div>
</div>

<div class="container mt-negative">

  <div class="row">
    <!-- <div class="col-md-12">
          <button type="button" class="btn btn-outline-light btn-sm">Music <i class="fa fa-times-circle"></i></button>
        </div> -->

    <div id="sidebar" class="col-md-4 type_div">
      <div class="row ">
        <div class="card sidebar-card">
          <p class="ml"><b>Types of Events</b></p>
          <div class="form-check" *ngFor="let category of categories">
            <input class="form-check-input" [(ngModel)]="category.isSelected" (change)="onChecked($event)"
              type="checkbox" value={{category.value}} id="defaultCheck1">
            <label class="form-check-label" for="defaultCheck1">
              {{category.value}}
            </label>
          </div>
        </div>
      </div>
    </div>

    <br>

    <div id="body-container" class="col">
      <div class="row d-flex justify-content-center" *ngIf="isLoading">
        <img class="loader" src="../../assets/images/loader.gif" alt="">
      </div>

      <!-- <div class="row mb-2 filter-button">
        <div class="col-md-12">
          <button type="button" (click)="onFilter()" class="btn btn-outline-light shadow lift">
             <p style="color: black; margin: 0; padding: 0">Filter</p>
          </button>
        </div>
      </div> -->

      <div class="row" *ngIf="searching && !searchResults">
        <div class="col-md-12">
          <h2>No records found</h2>
        </div>
        <div class="col-md-12">
          <p class="subtitle">There are no results matching your search : <b>{{displaySearchText}}</b></p>
        </div>
      </div>

      <div class="row" *ngIf="searching && searchResults">
        <div class="col-md-12">
          <h2>Search results:</h2>
        </div>
        <div class="col-md-12">
          <p class="subtitle">Search records found <b>( {{resultsValue}} )</b></p>
        </div>
      </div>

      <div class="row card_div">

        <pagination-controls *ngIf="showPagination" class="my-pagination" (pageChange)="p = $event">
        </pagination-controls>

        <div class="col-sm-12" *ngFor="let source of propertiesData | paginate: { itemsPerPage: 5, currentPage: p }">
          <div (click)="onView(source)" class="card border-light propertyCard">
            <div class="card-body">
              <div class="vertical-center">

                <div class="row">
                  <div class="col-md-3 nogutters d-flex justify-content-center">
                    <img class="event_logo rounded" src={{defaultImage}} alt="">
                  </div>
                  <div class="col-md-9 nogutters">
                    <div class="col-md-12">
                      <h4 class="cardHeading">{{source._source.name}}</h4>
                      <span>Category:</span> <span> {{source._source.category}}</span>
                      <span class="theme"> | </span>
                      <span><b>Type: {{source._source.type}}</b></span>
                      <span class="float-right date">{{source._source.creationDate | date}}</span>
                      <div class="row container">
                        <span>Industry: </span><span>{{source._source.industry}}</span>
                      </div>
                      <div class="row container">
                        <div class="col-md-4"></div>
                        <div class="col-md-4"></div>
                        <div class="col-md-4"></div>
                      </div>
                      <hr class="hr">
                      <div class="row container">
                        <div class="col-md-12">
                          <span class="theme">Description: </span> <span class="cardDescription">
                            {{source._source.description}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
              <!-- <img src="../../assets/images/arrow.svg" class="arrow" alt=""> -->
            </div>
          </div>
        </div>

        <pagination-controls *ngIf="showPagination" class="my-pagination m-t-1" (pageChange)="p = $event">
        </pagination-controls>

      </div>

      <div class="row d-flex justify-content-center" *ngIf="isButtonLoading">
        <img class="loader" src="../../assets/images/loader.gif" alt="">
      </div>

      <!-- <div class="row align-items-center text-center" *ngIf="!userLoggedOff && showAllButton">
        <button (click)="onShowMore()" class="btn btn-success showmore-button">
          Show All ...
        </button>
      </div> -->

      <!-- <div class="row align-items-center text-center" *ngIf="!userLoggedOff && showLessButton">
        <button (click)="onShowMore()" class="btn btn-success showmore-button">
          Show Less
        </button>
      </div> -->

      <div class="row m-t-2" *ngIf="!user || noProperty">
        <div class="col-sm-12">
          <hr class="line">
        </div>
      </div>

      <!-- <amplify-authenticator *ngIf="authState !== 'signedin'">
        <amplify-oauth-button provider="Google"></amplify-oauth-button>
        <amplify-oauth-button provider="Facebook"></amplify-oauth-button>
        <amplify-oauth-button provider="Amazon"></amplify-oauth-button>
      </amplify-authenticator> -->

      <div class="row align-items-center text-center m-t-2 m-b-4" *ngIf="userLoggedOff">
        <div class="col-sm-12 m-t-1">

          <h2 class="mb-5">Explore the full capability of the GaniSponsor Market Place</h2>
          <a class="btn text-primary btn-signUp mb-4 px-4" (click)="viewSignUp()">Sign Up<i class="ml-2"></i></a>
          <p>Already have an account, <a class="pointer" (click)="viewSignIn()">Sign In</a></p>
        </div>
      </div>

      <!-- <div class="row align-items-center text-center m-t-2 m-b-4" *ngIf="!userLoggedOff && noProperty">
        <div class="col-sm-12 m-t-1">

          <h2 class="mb-5">Register your first Property</h2>

          <p>You don't have any Properties, add your first Property</p>
          <a class="btn text-primary btn-signUp mb-4 px-4" href="/reg-page">Add<i class="ml-2"></i></a>
        </div>
      </div> -->



    </div>




  </div>




</div>


<app-tier-component [(visible)]="displayTier"></app-tier-component>

<!-- <i class="fa fa-filter"></i> -->

<app-footer></app-footer>